import { Container } from '@pixi/display';
import { Sprite } from '@pixi/sprite';
import { Ticker } from '@pixi/ticker';
import gsap from 'gsap';

import { Shared } from '../App';
import { Settings } from '../AppConfig';
import LocalisedText from './LocalisedText';

export class Logo extends Container
{
    public container: Container;
    private text: Sprite;
    private beta?: LocalisedText;
    private baseScale = 1;

    constructor()
    {
        super();
        this.container = new Container();
        this.addChild(this.container);
        
        let texture = Shared.assets.getTexture('title_logo_en');
        
        this.text = new Sprite(texture);
        this.text.anchor.set(0.5);
        this.container.addChild(this.text);
        
        if(Settings.browserLite){
            
            this.beta = new LocalisedText('subtitle', {
                fontFamily: 'lubalin',
                fill: 0xFFFFFF,
                stroke: 0x000000,
                strokeThickness: 16,
                lineJoin: 'round',
                align: 'center',
                fontSize: 40,
                maxWidth: 650,
            });
            this.beta.anchor.set(0.5);
            this.beta.y = 135;
            this.container.addChild(this.beta);
        }
        
        this.container.renderable = false;
        
        Shared.settings.languageChanged.connect(() => this.refresh());
        this.refresh();
    }

    public async show(): Promise<void>
    {
        this.killTweens();
        this.container.renderable = true;
        this.container.rotation = 0;
        this.container.scale.set(this.baseScale * 0.25);
        gsap.to(this.container.scale, { x: this.baseScale, y: this.baseScale, duration: 0.4, ease: 'back.out' });

        this.text.scale.set(0.5);
        gsap.to(this.text.scale, { x: 1, y: 1, duration: 0.6, ease: 'back.out' });
    }

    public async hide(): Promise<void>
    {
        this.killTweens();

        const scale = this.baseScale * 0.5;

        await gsap.to(this.container.scale, { x: scale, y: scale, duration: 0.3, ease: 'back.in' });
        this.container.renderable = false;
    }

    private killTweens(): void
    {
        gsap.killTweensOf(this.container.scale);
        gsap.killTweensOf(this.container);
        gsap.killTweensOf(this.text.scale);
        gsap.killTweensOf(this.text);
    }

    public updateTransform(): void
    {
        super.updateTransform();

        if(this.beta){
            this.updateBeta();
        }
    }

    private updateBeta(): void
    {
        if(this.beta){
            this.beta.scale.x = 1 + (Math.sin(Ticker.system.lastTime * 0.01) * 0.01);
            this.beta.scale.y = 1 + (Math.cos(Ticker.system.lastTime * 0.01) * 0.02);
        }
        
    }
    
    public refresh(): void
    {
        let texture = Shared.assets.getTexture('title_logo_en');
        var langShort = Shared.settings.language.substring(0, Shared.settings.language.indexOf('_'));

        if(Shared.assets.hasTexture(`title_logo_${Shared.settings.language}`)){
            texture = Shared.assets.getTexture(`title_logo_${Shared.settings.language}`);
        }
        else if(Shared.assets.hasTexture(`title_logo_${langShort}`)){
            texture = Shared.assets.getTexture(`title_logo_${langShort}`);
        }
        
        this.text.texture = texture;
    }
}
